import { render, staticRenderFns } from "./poster-edit.vue?vue&type=template&id=3a90c6b6&scoped=true"
import script from "./poster-edit.vue?vue&type=script&lang=js"
export * from "./poster-edit.vue?vue&type=script&lang=js"
import style0 from "./poster-edit.vue?vue&type=style&index=0&id=3a90c6b6&prod&lang=scss&scoped=true"
import style1 from "./poster-edit.vue?vue&type=style&index=1&id=3a90c6b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a90c6b6",
  null
  
)

export default component.exports